const rs_line = {
  dev: {
    env: "dev",
    // base_url: "https://6r0n1bt4j1.execute-api.us-east-1.amazonaws.com/v0",
    base_url: "https://f9rf4k91te.execute-api.us-east-1.amazonaws.com/v0",
    liff_id: "2005598024-XJz0d6bz",
    sigilUrl: "https://qa-sigil.qashopltk.com",
    legacyHomePage: "https://creator.qashopltk.com",
    accessTokenCookie: "qa_sigil_access_token",
    idTokenCookie: "qa_sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.qashopltk.com/v1",
      clientId: "4seva2GL8OhiWvEz1ilBhSqYhHCwuVDB",
      domain: "qa-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`
    }
  },

  qa: {
      env: "qa",
      // Old base_url for reference
      // base_url: "https://6r0n1bt4j1.execute-api.us-east-1.amazonaws.com/v0",
      // New base_url using CloudFront
      base_url: "https://f9rf4k91te.execute-api.us-east-1.amazonaws.com/v0",
      liff_id: "2005598024-XJz0d6bz",
      sigilUrl: "https://qa-sigil.qashopltk.com",
      legacyHomePage: "https://creator.qashopltk.com",
      accessTokenCookie: "qa_sigil_access_token",
      idTokenCookie: "qa_sigil_id_token",
      auth0: {
        audience: "https://creator-api-gateway.qashopltk.com/v1",
        // clientId: "CO8pzGyeIbIpxe84B0F11sQE2VKECCKo", // Old clientId for reference
        clientId: "4seva2GL8OhiWvEz1ilBhSqYhHCwuVDB", // wechat, line, kakao app clientId
        domain: "qa-rs-influencer.us.auth0.com",
        redirectUri: `${window.location.origin}/login/callback`
      }
  },

  prod: {
    env: "prod",
    base_url: "https://8wivowt9f5.execute-api.us-east-1.amazonaws.com/v0",
    liff_id: "1655254019-BOXV32k6",
    sigilUrl: "https://auth-creator.shopltk.com",
    legacyHomePage: "https://creator.shopltk.com",
    accessTokenCookie: "qa_sigil_access_token",
    idTokenCookie: "qa_sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.shopltk.com/v1",
      clientId: "NNaLFeMCaG65p35N4rQqI0zULtm3rfvV",
      domain: "prod-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`
    }
  }
};

export default rs_line;
